import { defineMessages } from 'react-intl';

export default defineMessages({
  selectCarrierServiceText: {
    description: 'Text displayed above the carrier service selector',
    defaultMessage: 'Services to Compare',
    id: 'z5CYtU',
  },
  serviceSelectorInstructionalText: {
    description: 'Instructional text displayed below the carrier service selector',
    defaultMessage: 'ShipStation will automatically choose the cheapest of these services',
    id: 'Wa0FPm',
  },
  deliveryTimeLabelText: {
    description: 'Label for the delivery time dropdown field',
    defaultMessage: 'Transit Time',
    id: 'cGzr5F',
  },
  backupDeliveryTimeLabelText: {
    description: 'Label for the backup delivery time dropdown field',
    defaultMessage: 'Fallback Transit Time',
    id: 'UdRE4V',
  },
  deliveryTimeInstructionalText: {
    description: 'Instructional text displayed below the delivery time dropdown field',
    defaultMessage:
      'Restricts eligible services to those that deliver within specified time (limited to services that provide transit time).',
    id: 'zWcz30',
  },
  backupDeliveryTimeInstructionalText: {
    description: 'Instructional text displayed below the backup delivery time dropdown field',
    defaultMessage: 'Fallback transit time used if order does not have a Deliver by Date',
    id: 'vou5gr',
  },
  deliveryTime3DaysText: {
    description: 'Text for the 3 days delivery time option',
    defaultMessage: '3 Business Days',
    id: '2yi6or',
  },
  deliveryTime5DaysText: {
    description: 'Text for the 5 days delivery time option',
    defaultMessage: '5 Business Days',
    id: 'r3Hiny',
  },
  deliveryTimeNoRestrictionText: {
    description: "Text for the transit time select field when one isn't selected",
    defaultMessage: 'No Restriction',
    id: 'jw/YGW',
  },
  deliveryTimeWithDayValueIncluded: {
    description: 'Text for the delivery time with day value included',
    defaultMessage: '{days, plural, one {# Business Day} other {# Business Days}}',
    id: 'hu6kQW',
  },
  serviceNameLabelText: {
    description: 'Label for the service name input',
    defaultMessage: 'Name',
    id: 'IigSQL',
  },
  saveShopperButtonText: {
    description: 'Text for the save shopper button',
    defaultMessage: 'Save',
    id: '9Hlhtl',
  },
  duplicateShopperButtonText: {
    description: 'Text for the duplicate shopper button',
    defaultMessage: 'Duplicate',
    id: 'sMTZV+',
  },
  deleteShopperButtonText: {
    description: 'Text for the delete shopper button',
    defaultMessage: 'Delete',
    id: 'HUvJ50',
  },
  publishNewShopperButtonText: {
    description: 'Text for the publish new shopper button',
    defaultMessage: 'Publish',
    id: 'GDNSGY',
  },
  emptyShopperNamePlaceholderText: {
    description: 'Placeholder text for the shopper name input when it is empty',
    defaultMessage: 'New Rate Shopper',
    id: '+T55Iz',
  },
  cheapestOverrideSectionHeaderText: {
    description: 'Text to show the merchant for when they include an override',
    defaultMessage: 'Preference <f>(optional)</f>',
    id: '1xJWEB',
  },
  selectServiceText: {
    description: 'Text displayed in the dropdown menu toggler',
    defaultMessage: 'Select Service',
    id: 're1JKr',
  },
  ifCheapestLabelWithinLabelText: {
    description: 'Label text for field where a merchant provides an override value',
    defaultMessage: 'If cheapest label is within',
    id: 'TyFqpf',
  },
  useThisServiceText: {
    description: 'Text displayed above the option to select a service as an override',
    defaultMessage: 'Use this service',
    id: 'PZYEln',
  },
  overrideDiscalimerText: {
    description: 'Text displayed below the service override label',
    defaultMessage: 'Override the service selection with “Service Preference”',
    id: 'I+MFV9',
  },
  deleteDisabledReason: {
    defaultMessage:
      'Rate Shoppers included in Automation Rules must remain active. To change this setting, please remove this shopper from any Automation Rules.',
    id: 'dxlGQs',
    description: 'Reason for delete button being disabled',
  },
  deliverByDate: {
    defaultMessage: 'Use Deliver By Date',
    id: 'AA0cjI',
    description: 'Deliver by date title',
  },
  includePackageAndConfirmationLabelText: {
    defaultMessage: 'Package + Confirmation Mode',
    id: '62ZAs7',
    description: 'Include package and confirmation label text',
  },
  serviceHeaderText: {
    defaultMessage: 'Service',
    id: 'fiFm8D',
    description: 'Service header text',
  },
  packageTypeHeaderText: {
    defaultMessage: 'Package Type',
    id: 'j1DZaI',
    description: 'Package Type header text',
  },
  confirmationTypeHeaderText: {
    defaultMessage: 'Confirmation Type',
    id: 'T0Bqer',
    description: 'Confirmation Type header text',
  },
  ariaTrashIcon: {
    defaultMessage: 'Delete',
    id: 'cdUC+s',
    description: 'Aria label for the trash icon',
  },
  addServiceButtonText: {
    defaultMessage: 'Add Service',
    id: '9F6y/J',
    description: 'Button text for adding a new service when package and confirmation are also included',
  },
  togglePackageConfirmationTooltipContent: {
    defaultMessage:
      'Enable this mode if your carriers require including package and confirmation type in addition to service class for accurate rates.',
    id: 'yoBq2+',
    description: 'Tooltip content for the package and confirmation toggle',
  },
  packageError: {
    defaultMessage: 'Package Required',
    id: '4aVm/A',
    description: 'Error message when no package is selected',
  },
  cancelEditShopperButtonText: {
    defaultMessage: 'Cancel',
    id: 'duYEDf',
    description: 'Cancel button text when editing a Rate Shopper',
  },
  cheapestWithin: {
    defaultMessage: 'If the cheapest label is within',
    id: '07b7kY',
    description: 'Label for the two options for cheapest override (currency or percent)',
  },
  cheapestOptionFixed: {
    description: 'Label for the fixed amount option for cheapest override',
    defaultMessage: 'Dollar Amount',
    id: 'NOwDvG',
  },
  cheapestOptionPercent: {
    description: 'Label for the percentage option for cheapest override',
    defaultMessage: 'Percentage Difference',
    id: 'n4QxCK',
  },
});
